import { firestore } from '../../../firebase';
import React, { useState } from 'react'

function AddAlbum() {

    const [title, setTitle] = useState("");
    const [photographer, setPhotographer] = useState("")
    const [coverImage, setCoverImage] = useState("");
    const [date, setDate] = useState()

    const [added, setAdded] = useState(false);
    const [error, setError] = useState(false)

    const [show, setShow] = useState(false);

    async function submitHandler(e) {

        e.preventDefault();

        const albumRef = firestore.collection("albums");

        const albumData = {
            title,
            photographer,
            cover_image: coverImage,
            date
        }
        try {
            albumRef.add(albumData)
            setAdded(true)
        } catch (error) {
            setError(true)
            console.log(error)
        }
        

    }
    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true)
        }
    }

    return (
        <div>

            <button className="btn btn-success" onClick={toggle}><i className="fas fa-plus"></i> Legg til nytt album</button>
            {show && (
                <form onSubmit={submitHandler}>
                    <label>Tittel på album</label>
                    <input className="form-control mb-2" value={title} onChange={e => setTitle(e.target.value)} />
                    <label>Fotograf / Kilde</label>
                    <input className="form-control mb-2" value={photographer} onChange={e => setPhotographer(e.target.value)} />
                    <label>Coverbilde</label>
                    <input className="form-control mb-2" value={coverImage} onChange={e => setCoverImage(e.target.value)} />
                    {coverImage && <img src={coverImage} className="img-fluid" />}

                    <label>Dato</label>
                    <input type="date" className="form-control mb-2" onChange={e => setDate(e.target.value)} />
                    {added && <div className="alert alert-success">Lagt til!</div>}
                    {error && <div className="alert alert-danger">Noe gikk galt, prøv igjen</div>}
                    <button className="btn btn-block btn-rounded btn-primary">Legg til album</button>
                </form>
            )}
        </div>
    )
}
export default AddAlbum